export class SchedulesCollisionError extends Error {
  constructor(message = 'Overlapping schedules') {
    super(message)
    this.name = 'SchedulesCollisionError'
    this.cause = 'Overlapping schedules'
    Object.setPrototypeOf(this, SchedulesCollisionError.prototype)
  }
}
